var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createMuiTheme } from "@material-ui/core/styles";
import { baseThemeOptions, createOverrides } from "../_base";
// See https://material-ui.com/customization/default-theme/ for avaliable options
var baseVodaTheme = createMuiTheme(__assign(__assign({}, baseThemeOptions), { typography: __assign(__assign({}, baseThemeOptions.typography), { fontFamily: "Vodafone, 'Open Sans', sans-serif" }), props: __assign(__assign({}, baseThemeOptions.props), { MuiPaper: {
            elevation: 3
        } }), palette: {
        primary: {
            main: "#e60000",
            contrastText: "#fff"
        },
        secondary: {
            main: "#333333"
        },
        info: {
            main: "#022f6b"
        },
        error: {
            main: "#a30115"
        },
        warning: {
            main: "#f29400"
        },
        success: {
            main: "#50b063",
            contrastText: "#fff"
        },
        background: {
            default: "#ffffff"
        },
        text: {
            primary: "#333333"
        },
        // we need a proper greyscale defining (see affinityTheme), but use these values for now.
        // will merge with default mui greyscale
        grey: {
            50: "#f8f7f9",
            100: "#e9e9ec",
            500: "#524b65",
            600: "#333333",
            800: "#140f1e" // neutralAbyss
        }
    } }) // TODO: fix typing error
);
// JSS styling overrides
var overrides = __assign({}, createOverrides(baseVodaTheme)
// add Voda specific overrides here
);
var vodaTheme = createMuiTheme(__assign(__assign({}, baseVodaTheme), { overrides: overrides }));
export { vodaTheme };
//# sourceMappingURL=index.js.map